(() => {
  const NAV_KEY = "navigation_origin";

  const getNavigationOrigin = () => {
    const url = new URL(window.location.href);

    const originParam = url.searchParams.get("origin");
    if (originParam === "fecosur" || originParam?.includes("cooperativa")) {
      return originParam;
    }

    if (url.pathname.includes("/collections/fecosur")) {
      return "fecosur";
    }

    const match = url.pathname.match(/\/collections\/(cooperativa-[^/?#]+)/);
    if (match && match[1]) {
      return match[1];
    }

    return sessionStorage.getItem(NAV_KEY) || "";
  };

  const navigationOrigin = getNavigationOrigin();

  if (!navigationOrigin) return;

  sessionStorage.setItem(NAV_KEY, navigationOrigin);

  document.body.classList.add("has-navigation-origin");

    if (navigationOrigin === "fecosur") {
    document.body.classList.add("navigation-origin-fecosur");
    }

    if (navigationOrigin.includes("cooperativa")) {
    document.body.classList.add("navigation-origin-cooperativa");
    }

  const homeUrl =
    navigationOrigin === "fecosur"
      ? "/collections/fecosur"
      : `/collections/${navigationOrigin}`;

  document
    .querySelectorAll('.header__heading-link, .header__menu-item[href="/"], a[href="/"]')
    .forEach((link) => {
        link.href = homeUrl;
    });
})();